import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloudy-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-vip-crown-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-bear-smile-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

const blogLinks = [
  { name: 'Complete Guide', path: '/superbuy-spreadsheet-complete-guide' },
  { name: 'Beginner Guide', path: '/superbuy-spreadsheet-beginner-guide' },
  { name: 'Templates Guide', path: '/superbuy-spreadsheet-templates-guide' },
  { name: 'Safety Guide', path: '/superbuy-spreadsheet-safety-guide' },
];

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isBlogOpen, setIsBlogOpen] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const blogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsDropdownOpen(false);
      }
      if (blogRef.current && !blogRef.current.contains(e.target as Node)) {
        setIsBlogOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const textClass = isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white';

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'}`}>
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <div className="flex items-center gap-8">
            <Link to="/" className={`font-heading text-lg md:text-xl font-semibold tracking-tight whitespace-nowrap ${isScrolled ? 'text-foreground-950' : 'text-white'}`}>
              Superbuy Spreadsheet
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <Link to="/superbuy-spreadsheet-beginner-guide" className={`text-sm font-medium whitespace-nowrap transition-colors ${textClass}`}>Beginner Guide</Link>
              <Link to="/superbuy-spreadsheet-templates-guide" className={`text-sm font-medium whitespace-nowrap transition-colors ${textClass}`}>Templates</Link>
              <a href="#comparisons" className={`text-sm font-medium whitespace-nowrap transition-colors ${textClass}`}>Comparisons</a>

              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${textClass}`}
                >
                  Categories
                  <span className={`w-4 h-4 flex items-center justify-center transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-xs"></i>
                  </span>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 rounded-lg border border-background-200/70 py-2 max-h-80 overflow-y-auto">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        <span className="w-4 h-4 flex items-center justify-center text-foreground-400"><i className={cat.icon}></i></span>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative" ref={blogRef}>
                <button
                  onClick={() => setIsBlogOpen(!isBlogOpen)}
                  className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${textClass}`}
                >
                  Blog
                  <span className={`w-4 h-4 flex items-center justify-center transition-transform ${isBlogOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-xs"></i>
                  </span>
                </button>
                {isBlogOpen && (
                  <div className="absolute top-full left-0 mt-2 w-52 bg-background-50 rounded-lg border border-background-200/70 py-2">
                    {blogLinks.map((link) => (
                      <Link
                        key={link.path}
                        to={link.path}
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap"
                        onClick={() => setIsBlogOpen(false)}
                      >
                        <span className="w-4 h-4 flex items-center justify-center text-accent-500"><i className="ri-article-line"></i></span>
                        {link.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/superbuy-spreadsheet-safety-guide" className={`hidden md:block text-sm font-medium whitespace-nowrap transition-colors ${textClass}`}>Safety</Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`hidden md:inline-flex items-center px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer ${isScrolled ? 'bg-primary-500 text-background-50 hover:bg-primary-600' : 'bg-white text-foreground-950 hover:bg-white/90'}`}
            >
              Superbuy Sheet
            </a>
            <button
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${isScrolled ? 'text-foreground-950' : 'text-white'}`}
              aria-label="Toggle menu"
            >
              <i className={`ri-${isMobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-6 py-5 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
            <div className="mb-3">
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-3 px-1">Navigation</p>
              <div className="flex flex-col gap-0.5">
                <Link to="/superbuy-spreadsheet-beginner-guide" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors" onClick={() => setIsMobileOpen(false)}>
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500"><i className="ri-play-circle-line"></i></span>
                  Beginner Guide
                </Link>
                <Link to="/superbuy-spreadsheet-templates-guide" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors" onClick={() => setIsMobileOpen(false)}>
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500"><i className="ri-file-copy-line"></i></span>
                  Templates Guide
                </Link>
                <a href="#comparisons" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors" onClick={() => setIsMobileOpen(false)}>
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500"><i className="ri-scales-line"></i></span>
                  Comparisons
                </a>
                <Link to="/superbuy-spreadsheet-complete-guide" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors" onClick={() => setIsMobileOpen(false)}>
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500"><i className="ri-book-open-line"></i></span>
                  Complete Guide
                </Link>
                <Link to="/superbuy-spreadsheet-safety-guide" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors" onClick={() => setIsMobileOpen(false)}>
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500"><i className="ri-shield-check-line"></i></span>
                  Safety Guide
                </Link>
              </div>
            </div>

            <div className="border-t border-background-200/70 pt-4">
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-3 px-1">Shop Categories</p>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat, idx) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer ${idx === 0 ? 'ring-1 ring-accent-200/50 bg-accent-50/30' : ''}`}
                    onClick={() => setIsMobileOpen(false)}
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-foreground-400"><i className={cat.icon}></i></span>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="border-t border-background-200/70 pt-4 mt-1">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer"
              >
                Superbuy Sheet
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line"></i></span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-5 py-3 mt-2 rounded-full border-2 border-foreground-300 text-sm font-semibold text-foreground-800 hover:bg-foreground-100 transition-all cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}